import { APP_INITIALIZER, Injector, NgModule, inject } from '@angular/core';
import { SecurityModule } from '../security/security.module';
import { KeepAliveService } from './services/keep-alive.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { KeepAliveInterceptor } from './interceptors/keep-alive.interceptor';

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (service: KeepAliveService) => (): KeepAliveService => service,
      deps: [KeepAliveService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeepAliveInterceptor,
      multi: true
    }
  ],
  imports: [SecurityModule]
})
export class KeepAliveModule {
  public static injector: Injector;

  constructor() {
    const injector = inject(Injector);

    KeepAliveModule.injector = injector;
  }
}
